// extracted by mini-css-extract-plugin
export var active = "_si-1";
export var circle = "_si-0";
export var completed = "_si-2";
export var connector = "_si-4";
export var connectorCompleted = "_si-7";
export var connectorSpacer = "_si-5";
export var iconStrokeOverride = "_si-8";
export var labelContainer = "_si-6";
export var pending = "_si-3";